import React, {useState} from 'react';
import {NavigationContainer } from "@react-navigation/native";
import { createNativeStackNavigator } from "@react-navigation/native-stack";
import { configureStore } from '@reduxjs/toolkit'
import {Provider, useSelector} from 'react-redux';
import {useFonts} from "expo-font";

import './function/i18n';
import {useTranslation} from 'react-i18next';

import * as WebBrowser from 'expo-web-browser';
import * as Google from 'expo-auth-session/providers/google';

import Moment from "moment";

import {SettingsScreen} from "./screen/SettingsScreen";
import {MatrixScreen} from "./screen/MatrixScreen";
import {BalanceScreen} from "./screen/BalanceScreen";
import {setStore} from "./function/functions";
import {HomeScreen} from "./screen/HomeScreen";
import {Button, Pressable, Text, View} from "react-native";
import SettingsButton from "./component/SettingsButton";
import {LangScreen} from "./screen/LangScreen";
import {ThemeScreen} from "./screen/ThemeScreen";
import AuthButton from "./component/AuthButton";


let today = Moment().format('DD.MM.YYYY');

const defaultState = {
    tasks: {},
    completed: 0,
    total: 0,
    viewCompleted: false,
    date: today,
    period: {from: today, to: today},
    lang: 'ru',
    langs: [
        'kz', 'ru', 'en'
    ],
    settings: {
        auth: {enabled:true, visible:true},
        balance: {enabled:false, visible:true},
        matrix: {enabled:false, visible:true},
        //achievements: {enabled:false, title: 'Достижения'},
        transfer: {enabled:false, visible:true},
        viewtask: {enabled:true, visible:true},
        //subtask: {enabled:false, title: 'Разрешить добавлять подзадачи'},
        //editable: {enabled:true, title: 'Редактирование задач'},
        deletable: {enabled:true, visible:true}
    },
    balance: {
        1: {id: 1, title: 'career', color: '#ff6961'},
        2: {id: 2, title: 'finance', color: '#ffb480'},
        3: {id: 3, title: 'health', color: '#f8f38d'},
        4: {id: 4, title: 'friends', color: '#42d6a4'},
        5: {id: 5, title: 'family', color: '#08b0b6'},
        6: {id: 6, title: 'growth', color: '#4b9cd9'},
        7: {id: 7, title: 'recreation', color: '#5758c5'},
        8: {id: 8, title: 'condition', color: '#8e37b7'}
    },
    theme: 'light',
    themes: ['light', 'dark', 'contrast-light']
}
const reducer = (state = defaultState, action) => {
    switch (action.type) {
        case 'ADD_TASK':
            return {...state, tasks: {...state.tasks, ...action.payload}, total: state.total + 1}
        case 'EDIT_TASK':
            return {
                ...state,
                tasks: {...state.tasks, ...{[action.payload.id]: {...state.tasks[action.payload.id], ...action.payload.data}}}
            }
        case 'REMOVE_TASK':
            let tasks = {...state.tasks};
            delete(tasks[action.payload.id]);
            return {...state, tasks: tasks, total: state.total - 1, completed: action.payload.complete ? state.completed - 1 : state.completed};
        case 'COMPLETE_TASK':
            return {
                ...state,
                tasks: {...state.tasks, ...{[action.payload.id]: {...state.tasks[action.payload.id], ...{complete: action.payload.complete}}}},
                completed: (action.payload.complete ? state.completed + 1 : state.completed - 1)
            }
        case 'CHANGE_SETTINGS':
            return {
                ...state,
                settings: {...state.settings, ...{[action.payload.id]: {...state.settings[action.payload.id], ...{enabled: action.payload.enabled}}}}
            }
        case 'SAVE_TASK':
            let tasksJSON = JSON.stringify(state.tasks);
            setStore('@wtitl.' + state.date, tasksJSON).then(r => {

            });
            return state;
        case 'SAVE_SETTINGS':
            let settingsJSON = JSON.stringify(state.settings);
            setStore('@wtitl.settings', settingsJSON).then(r => {
            });
            return state;
        case 'LOAD_THEME':
        case 'LOAD_TASK':
        case 'RESET_TASK':
        case 'CHANGE_VIEWTASK':
        case 'LOAD_LANG':
            return {...state, ...action.payload}
        case 'CHANGE_LANG':
            setStore('@wtitl.lang', action.payload.lang).then(r => {
            });
            return {...state, ...action.payload}
        case 'CHANGE_THEME':
            setStore('@wtitl.theme', action.payload.theme).then(r => {
            });
            return {...state, ...action.payload}
        case 'LOAD_SETTINGS':
            let settings = {...state.settings};

            Object.keys(action.payload.settings).forEach((prop, index) => {
                if (state.settings?.[prop]) settings[prop] = action.payload.settings[prop];
            })
            return {...state, ...{settings:{...settings}}}
        case 'CHANGE_DATE':
            return {...state, ...{date: action.payload}}
        default:
            return state;
    }
}
const store = configureStore({ reducer: reducer });


const themes = {
    light : {
        dark: false,
        colors: {
            primary: '#fff',
            background: '#fff',
            card: '#CCDBB2',
            text: '#4B402A',
            border: '#CCDBB2',
            notification: '#fff',
            scheme: [
                '#ECDBAD',
                '#C15143',
                '#4B402A',
                '#CCDBB2',
                '#F1FACF',
                '#F1FACF',
                '#CCDBB2'
            ],
            barStyle: "dark-content"
        }
    },
    dark : {
        dark: false,
        colors: {
            primary: '#121212',
            background: '#13121A',
            card: '#13121A',
            text: '#8673bf',
            border: '#13121A',
            notification: '#121212',
            scheme: [
                '#4f493b',
                '#3f3c54',
                '#8673bf',
                '#13121A',
                '#232634',
                '#232634',
                '#13121A'
            ],
            barStyle: "light-content"
        }
    },
    'contrast-light' : {
        dark: false,
        colors: {
            primary: '#121212',
            background: '#FFFFFF',
            card: '#FFFFFF',
            text: '#121212',
            border: '#FFFFFF',
            notification: '#121212',
            scheme: ['#FFFFFF', '#121212', '#121212', '#FFFFFF', '#FFFFFF', '#121212', '#121212'],
            barStyle: "light-content"
        }
    }
};
WebBrowser.maybeCompleteAuthSession();

export default function App() {
    const Stack = createNativeStackNavigator();
    const [theme, setTheme] = useState('light');
    const {t, i18n} = useTranslation();
    const [fontsLoaded] = useFonts({
        'Roboto-Black': require('./assets/fonts/Roboto/Roboto-Black.ttf'),
        'Roboto-Regular': require('./assets/fonts/Roboto/Roboto-Regular.ttf'),
        'Roboto-Light': require('./assets/fonts/Roboto/Roboto-Light.ttf'),
        'Roboto-Thin': require('./assets/fonts/Roboto/Roboto-Thin.ttf'),
    });
    if (!fontsLoaded) {
        return null;
    }
    return (
        <Provider store={store}>
        <NavigationContainer theme={themes[theme]}>
            <Stack.Navigator initialRouteName="Home">
                <Stack.Screen name="Home" options={
                    {
                        title: t('appname'),
                        headerRight: () => (<View style={{display:'flex', flexDirection:'row', flexWrap:'nowrap'}}><AuthButton></AuthButton><SettingsButton /></View>),
                    }
                }>
                    {(props) => <HomeScreen {...props} setTheme={setTheme} />}
                </Stack.Screen>
                <Stack.Screen name="Settings" options={{title: t('settings.header')}} component={SettingsScreen} />
                <Stack.Screen name="Matrix" options={{title: t('matrix.header')}} component={MatrixScreen} />
                <Stack.Screen name="Balance" options={{title: t('balance.header')}} component={BalanceScreen} />
                <Stack.Screen name="Lang" options={{title: t('lang.header')}} component={LangScreen} />
                <Stack.Screen name="Theme" options={{title: t('theme.header')}} component={ThemeScreen} />
            </Stack.Navigator>
        </NavigationContainer>
        </Provider>
    );
}
